import { getFieldAuthority, getFormAuthority } from "../../auth/authHelper";

// Filter Columns based on permissions.
export const getAuthenticatedConfig = (gridConfig, auth, flex) => {
  const authenticatedConfig = [];
  for (let config of gridConfig) {
    const { view, authorized } = getFieldAuthority(
      auth,
      config?.primaryForm ? config.primaryForm : "",
      config?.field ? config.field : "",
      false,
      false,
    );

    const { view: secFormView } = getFormAuthority(
      auth,
      config?.secondaryForm ? config?.secondaryForm : "",
      false,
    );

    if (config.authenticated) {
      if (config.editable) {
        if (view) {
          if (authorized) {
            authenticatedConfig.push(flex ? { ...config, flex: 1 } : config);
          } else {
            authenticatedConfig.push(
              flex
                ? { ...config, editable: false, flex: 1 }
                : { ...config, editable: false },
            );
          }
        }
      } else {
        if (config.consider === "SECOND_FORM") {
          if (secFormView) {
            authenticatedConfig.push(flex ? { ...config, flex: 1 } : config);
          }
        } else {
          if (view) {
            authenticatedConfig.push(flex ? { ...config, flex: 1 } : config);
          }
        }
      }
    } else {
      authenticatedConfig.push(flex ? { ...config, flex: 1 } : config);
    }
  }

  return authenticatedConfig;
};

// Filter Columns based on custom column config.
export const getCustomConfig = (
  auth,
  gridConfig,
  persistColumnConfig,
  storageKey,
  withWidth = false,
) => {
  let savedConfig = {};

  if (persistColumnConfig && storageKey) {
    const saved = localStorage.getItem(storageKey);
    savedConfig = saved ? JSON.parse(saved) ?? {} : {};
  }

  let count = 1;
  const newConfig = [];
  for (let config of gridConfig) {
    if (gridConfig) {
      if (savedConfig && Object.keys(savedConfig).length > 0) {
        const savedItem = savedConfig[config.field];
        if (savedItem && savedItem.visible) {
          if (withWidth) {
            newConfig.push({
              ...config,
              customSeq: savedItem.customSeq,
              pinned: savedItem.pinned,
              width: savedItem.width,
              flex: savedItem.width ? undefined : 1,
            });
          } else {
            newConfig.push({
              ...config,
              customSeq: savedItem.customSeq,
              pinned: savedItem.pinned,
              flex: 1,
            });
          }
        }
      } else {
        newConfig.push({
          ...config,
          customSeq: count,
          flex: 1,
        });
        count++;
      }
    }
  }

  return savedConfig
    ? newConfig.sort((a, b) => a.customSeq - b.customSeq)
    : newConfig;
};

export const getDefaultConfig = (config) => {
  return config.reduce((acc, con, index) => {
    acc[con.field] = {
      label: con.headerName ?? con.field,
      visible: true,
      pinned: con.pinned,
      customSeq: index + 1,
    };
    return acc;
  }, {});
};
